import { MdOutlineVisibility } from "react-icons/md"

function EyeIcon() {
    return (
        <MdOutlineVisibility size={20}/>
    )
}

export default EyeIcon